import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Col, Row } from '@storable/canaveral-components';
import { CONSUL, ROBOCERT, SSL_PROVIDERS } from '../../../constants/sslProviders';
import styles from './styles.scss';

const expiresSoon = (validTo) => {
  const now = new Date();
  now.setDate(now.getDate() + 30);
  return validTo < now.valueOf();
};

const getSSLStatusText = (ssl, sslType, websitePlatform) => {
  if (websitePlatform !== 'voyager' && (ssl && sslType === ROBOCERT)) {
    return 'Ready to be Secured';
  }

  if (!ssl) {
    return 'Not Secure';
  }

  if (sslType === ROBOCERT) {
    return 'Secure - LetsEncrypt';
  }

  if (sslType === CONSUL && ssl) {
    return 'Secure - GoDaddy';
  }

  return '';
};

const renderRenewalStatus = (ssl, sslType, validTo) => {
  if (!ssl) {
    return null;
  }

  if (sslType === ROBOCERT) {
    return (
      <>
        <span className={cx('fa', 'fa-check-circle', `${styles.checkIcon}`)} />
        <span className={styles.iconText}>Auto Renews</span>
      </>
    );
  }

  if (expiresSoon(validTo)) {
    return (
      <>
        <span className={cx('fa', 'fa-exclamation-triangle', `${styles.warningIcon}`)} />
        <span className={styles.iconText}>Expires: {new Intl.DateTimeFormat('en-US', { dateStyle: 'long' }).format(new Date(validTo))}</span>
      </>
    );
  }

  return (
    <>
      <span className={cx('fa', 'fa-check-circle', `${styles.checkIcon}`)} />
      <span className={styles.iconText}>Expires: {new Intl.DateTimeFormat('en-US', { dateStyle: 'long' }).format(new Date(validTo))}</span>
    </>
  );
};

const propTypes = {
  ssl: PropTypes.bool.isRequired,
  sslType: PropTypes.oneOf(SSL_PROVIDERS),
  validTo: PropTypes.string,
  websitePlatform: PropTypes.string,
};

const defaultProps = {
  sslType: undefined,
  validTo: '0',
  websitePlatform: '',
};

const HostnameCertSettingsStatusIcons = ({
  ssl,
  sslType,
  validTo,
  websitePlatform,
}) => (
  <div className={styles.statusIconsContainer}>
    <Row>
      <Col xs={4} className={styles.lockColumn}>
        <span className={cx('fa', `fa-${ssl && websitePlatform === 'voyager' ? 'lock' : 'unlock'}`, `${styles.lockIcon}`)} />
        <span className={styles.iconTextLight}>
          {getSSLStatusText(ssl, sslType, websitePlatform)}
        </span>
      </Col>
      <Col xs={4} className={styles.status}>
        { renderRenewalStatus(ssl, sslType, Number(validTo)) }
      </Col>
    </Row>
  </div>
);

HostnameCertSettingsStatusIcons.propTypes = propTypes;
HostnameCertSettingsStatusIcons.defaultProps = defaultProps;

export default HostnameCertSettingsStatusIcons;
